import type { EmployeeDocument, DataResponse } from '@pms/shared';
import { api } from '@/lib/api';

export const staffDocumentsService = {
  async list(userId: string): Promise<EmployeeDocument[]> {
    const res = await api.get<{ data: EmployeeDocument[] }>(`/staff-documents/staff/${userId}`);
    return res.data.data;
  },

  async upload(userId: string, file: File): Promise<{ id: string }> {
    const form = new FormData();
    form.append('file', file);
    const res = await api.post<DataResponse<{ id: string }>>(
      `/staff-documents/staff/${userId}`,
      form,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
    return res.data.data;
  },

  /** The logged-in user's own documents — works without HR staff access. */
  async listMine(): Promise<EmployeeDocument[]> {
    const res = await api.get<{ data: EmployeeDocument[] }>('/staff-documents/me');
    return res.data.data;
  },

  async remove(docId: string): Promise<void> {
    await api.delete(`/staff-documents/${docId}`);
  },

  /** Pass basePath `/staff-documents/me` for the caller's own files (self-service route). */
  async download(docId: string, filename: string, basePath = '/staff-documents'): Promise<void> {
    const res = await api.get<Blob>(`${basePath}/${docId}/download`, { responseType: 'blob' });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  },
};
